<template>
  <div class="wxDefault">
    <div class="line">
      <img class="lineImg" src="../assets/wx/line.png" alt="">
    </div>
    <img v-if="isIOS" class="icon" src="../assets/wx/safari1.png" alt="">
    <img v-else class="icon" src="../assets/wx/browser1.png" alt="">
    <div class="tips">{{ isIOS ? $t('clickRightTopIOS') : $t('clickRightTopAndroid') }}</div>
    <div class="button" @click="hide">{{ $t('ok') }}</div>
  </div>
</template>

<script>
import device from '@/mx-service/libs/utils/device'

export default {
  name: 'wxDefault',
  data() {
    return {
      isIOS: device.isIOS()
    }
  },
  methods: {
    hide(){
      console.log(123123)
      this.$emit('hideWX', false)
    }
  }
}
</script>
<style lang="less">
.wxDefault {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: rgba(0, 0, 0, .6);
  .line {
    position: absolute;
    top: 0;
    right: 0;
    padding: 20px;
    width: 100px;
    .lineImg {
      width: 100%;
    }
  }
  .icon {
    width: 60px;
    height: 60px;
    margin-bottom: 24px;
  }
  .tips {
    font-size: 14px;
    color: #fff;
  }
  .button {
    width: 50%;
    padding: 14px 0;
    box-sizing: border-box;
    border-radius: 28px;
    border: 2px solid #E5E5E5;
    margin-top: 150px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 20px;
  }
}
</style>